import {
  addObj,
  getAll,
  searchByName,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  bindSimInfos,
  unBindSimInfos,
  quicklyGenerateCertificate,
  generateCertificate,
} from '@/api/positioningdeviceinfoserv'

export default {
  state: {
    state_PositioningDeviceInfo_AddObjResult: null,
    state_PositioningDeviceInfo_GetAllResult: null,
    state_PositioningDeviceInfo_SearchByNameResult: null,
    state_PositioningDeviceInfo_GetPageResult: null,
    state_PositioningDeviceInfo_GetDetailResult: null,
    state_PositioningDeviceInfo_ModifyObjResult: null,
    state_PositioningDeviceInfo_DeleteObjResult: null,
    state_PositioningDeviceInfo_BindSimInfosResult: null,
    state_PositioningDeviceInfo_UnBindSimInfosResult: null,
    state_PositioningDeviceInfo_QuicklyGenerateCertificateResult: null,
    state_PositioningDeviceInfo_GenerateCertificateResult: null,
  },
  mutations: {
    SET_POSITIONINGDEVICEINFO_ADDOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_AddObjResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GETALL_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GetAllResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_SearchByNameResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GETPAGE_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GetPageResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GETDETAIL_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GetDetailResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_ModifyObjResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_DELETEOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_DeleteObjResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_BINDSIMINFOS_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_BindSimInfosResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_UNBINDSIMINFOS_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_UnBindSimInfosResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_QUICKLYGENERATECERTIFICATE_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_QuicklyGenerateCertificateResult = rst;
    },
    SET_POSITIONINGDEVICEINFO_GENERATECERTIFICATE_RESULT: (state, rst) => {
      state.state_PositioningDeviceInfo_GenerateCertificateResult = rst;
    },
  },
  actions: {
    PositioningDeviceInfoServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_BindSimInfos({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        bindSimInfos(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_BINDSIMINFOS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_BINDSIMINFOS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_UnBindSimInfos({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        unBindSimInfos(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_UNBINDSIMINFOS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_UNBINDSIMINFOS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_QuicklyGenerateCertificate({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        quicklyGenerateCertificate(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_QUICKLYGENERATECERTIFICATE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_QUICKLYGENERATECERTIFICATE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PositioningDeviceInfoServ_GenerateCertificate({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        generateCertificate(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEINFO_GENERATECERTIFICATE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_POSITIONINGDEVICEINFO_GENERATECERTIFICATE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_PositioningDeviceInfo_AddObjResult: state => {
      return state.state_PositioningDeviceInfo_AddObjResult;
    },
    get_PositioningDeviceInfo_GetAllResult: state => {
      return state.state_PositioningDeviceInfo_GetAllResult;
    },
    get_PositioningDeviceInfo_SearchByNameResult: state => {
      return state.state_PositioningDeviceInfo_SearchByNameResult;
    },
    get_PositioningDeviceInfo_GetPageResult: state => {
      return state.state_PositioningDeviceInfo_GetPageResult;
    },
    get_PositioningDeviceInfo_GetDetailResult: state => {
      return state.state_PositioningDeviceInfo_GetDetailResult;
    },
    get_PositioningDeviceInfo_ModifyObjResult: state => {
      return state.state_PositioningDeviceInfo_ModifyObjResult;
    },
    get_PositioningDeviceInfo_DeleteObjResult: state => {
      return state.state_PositioningDeviceInfo_DeleteObjResult;
    },
    get_PositioningDeviceInfo_BindSimInfosResult: state => {
      return state.state_PositioningDeviceInfo_BindSimInfosResult;
    },
    get_PositioningDeviceInfo_UnBindSimInfosResult: state => {
      return state.state_PositioningDeviceInfo_UnBindSimInfosResult;
    },
    get_PositioningDeviceInfo_QuicklyGenerateCertificateResult: state => {
      return state.state_PositioningDeviceInfo_QuicklyGenerateCertificateResult;
    },
    get_PositioningDeviceInfo_GenerateCertificateResult: state => {
      return state.state_PositioningDeviceInfo_GenerateCertificateResult;
    },
  }
}